import Auth from "@layouts/Auth/Auth";
import Dashboard from "@layouts/Dashboard/Dashboard";
import Home from "@pages/App/Home";
import ConfirmReset from "@pages/Auth/ConfirmReset/ConfirmReset";
import ForgotPassword from "@pages/Auth/ForgotPassword/ForgotPassword";
import Login from "@pages/Auth/Login";
import OTPLogin from "@pages/Auth/Login/components/OTPLogin/OTPLogin";
import TFALogin from "@pages/Auth/Login/components/TFALogin/TFALogin";
import Register from "@pages/Auth/Register";
import VerifyEmail from "@pages/Auth/VerifyEmail/VerifyEmail";
import axios from "axios";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Settings from "./pages/App/Settings/Settings";
import Profile from "./pages/App/Settings/pages/Profile/Profile";
import TwoFactor from "./pages/App/Settings/pages/TwoFactor/TwoFactor";
import Notifications from "./pages/App/Settings/pages/Notifications/Notifications";
import Account from "./pages/App/Settings/pages/Account/Account";
import Verifications from "./pages/App/Settings/pages/Verifications/Verifications";
import PaymentMethods from "./pages/App/PaymentMethods";
import Rewards from "./pages/App/Rewards";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { signOut } from "./features/userSlice";
import Ussd from "./pages/App/Settings/pages/Ussd/Ussd";
import { MantineProvider } from "@mantine/core";
import BuySell from "./pages/App/BuySell";
import DirectTrade from "./pages/App/DirectTrade/DirectTrade";
import P2pTrade from "./pages/App/P2PTrade";
import TradeDetails from "./pages/App/P2PTrade/components/TradeDetails";
import MyOffers from "./pages/App/MyOffers";
import Create from "./pages/App/MyOffers/create";
import TraderInfo from "./pages/App/P2PTrade/components/TraderInfo";
import Wallet from "./pages/App/Wallet";
import Overview from "./pages/App/Wallet/components/Overview";
import Trading from "./pages/App/Wallet/components/Trading";
import Funding from "./pages/App/Funding/Funding";
import Deposit from "./pages/App/Funding/components/Deposit";
import Withdraw from "./pages/App/Funding/components/Withdraw";
import History from "./pages/App/Wallet/components/History";
import Refer from "./pages/App/Rewards/components/Refer";
import Winnings from "./pages/App/Rewards/components/Winnings";
import Convert from "./pages/App/Funding/components/Convert";
import Main from "./pages/App/Settings/pages/SecurityCenter/components/Main";
import TfaEnabled from "./pages/App/Settings/pages/SecurityCenter/components/TfaEnabled";
import ChangePassword from "./pages/App/Settings/pages/SecurityCenter/components/ChangePassword";
import DeleteAccount from "./pages/App/Settings/pages/SecurityCenter/components/DeleteAccount";
import { useEffect } from "react";
import Update from "./pages/App/MyOffers/update";
import { NuqsAdapter } from "nuqs/adapters/react-router";
import Scan from "./pages/App/Rewards/components/Scan";
// import initializeLogRocket from "./helpers/logrocket";

function App() {
  const dispatch = useAppDispatch();
  const { isLoggedIn, user, lastPath } = useAppSelector((state) => state.user);

  // initializeLogRocket(user?.username ?? undefined);

  axios.interceptors.response.use(
    function (response) {
      if (typeof response?.data?.info === "string") {
        if (response?.data?.info.includes("L105")) {
          dispatch(signOut());
          window.location.assign("/");
        }
        return response;
      }
      return response;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  axios.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      if (user?.token !== undefined) {
        config.headers["Authorization"] = `Bearer ${user?.token}`;
      }
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  useEffect(
    function authorizedOnly() {
      if (
        (window.location.pathname === "/" ||
          window.location.pathname.includes("/auth")) &&
        !isLoggedIn
      ) {
        return;
      }
      if (isLoggedIn) {
        if (
          window.location.pathname === "/" ||
          window.location.pathname.includes("/auth")
        ) {
          window.location.assign(lastPath as string);
        }
      } else {
        if (
          !window.location.pathname.includes("/auth") ||
          window.location.pathname !== "/"
        ) {
          window.location.assign("/");
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [window.location.pathname]
  );

  // if (data?.maintenance) return <Maintenance data={data} />;

  return (
    <MantineProvider withGlobalStyles withNormalizeCSS>
      <NuqsAdapter>
        <BrowserRouter>
          <Routes>
            <Route path={"/"} element={<Auth />}>
              <Route index element={<Login />} />
              <Route path="auth/confirm_otp" element={<OTPLogin />} />
              <Route path="auth/2-fa" element={<TFALogin />} />
              <Route path="auth/register" element={<Register />} />
              <Route path="auth/join/:referral_code" element={<Register />} />
              <Route path="auth/reset/:token" element={<ConfirmReset />} />
              <Route
                path="auth/confirm_email/:token"
                element={<VerifyEmail />}
              />
              <Route path="auth/forgotpassword" element={<ForgotPassword />} />
            </Route>
            <Route path={"/auth"} element={<Auth />}>
              <Route index element={<Login />} />
            </Route>
            <Route path="/app" element={<Dashboard />}>
              <Route index path="/app/home" element={<Home />} />
              <Route path="trade" element={<BuySell />}>
                <Route path=":trade_type" element={<DirectTrade />} />
                <Route path="p2p" element={<P2pTrade />} />
                <Route path="ad/:id" element={<TradeDetails />} />
                <Route path="myoffers" element={<MyOffers />} />
                <Route path="create" element={<Create />} />
                <Route path="update/:id" element={<Update />} />
                <Route path="trader_info/:username" element={<TraderInfo />} />
                {/* <Route path="history" element={<TradeHistory />} /> */}
              </Route>
              {/* <Route path="wallet" element={<Funding />} /> */}
              <Route path="wallet" element={<Wallet />}>
                <Route index element={<Overview />} />
                <Route path="trading" element={<Trading />} />
                <Route path="history" element={<History />} />
                <Route path="funding" element={<Funding />}>
                  <Route index element={<Deposit />} />
                  <Route path="withdraw" element={<Withdraw />} />
                  <Route path="convert" element={<Convert />} />
                </Route>
              </Route>
              {/* <Route path="p2p" element={<Offers />} /> */}
              {/* <Route path="myoffers" element={<MyOffers />} /> */}
              <Route path="payments" element={<PaymentMethods />} />
              <Route path="payments/:type" element={<PaymentMethods />} />
              <Route path="earn" element={<Rewards />}>
                <Route index element={<Refer />} />
                <Route path="rewards" element={<Winnings />} />
                <Route path="scan" element={<Scan />} />
              </Route>
              {/* <Route path="history" element={<History />} /> */}
              <Route path="settings" element={<Settings />}>
                <Route index path="profile" element={<Profile />} />
                <Route path="tfa" element={<TwoFactor />} />
                <Route path="notifications" element={<Notifications />} />
                <Route path="account" element={<Account />} />
                <Route path="verifications" element={<Verifications />} />
                <Route path="ussd" element={<Ussd />} />
                <Route path="security-center">
                  <Route index element={<Main />} />
                  <Route path="tfa-enabled" element={<TfaEnabled />} />
                  <Route path="change-password" element={<ChangePassword />} />
                  <Route path="delete-account" element={<DeleteAccount />} />
                </Route>
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </NuqsAdapter>
    </MantineProvider>
  );
}

export default App;
